import { render, staticRenderFns } from "./inline_parent_invite.vue?vue&type=template&id=3c405aeb&"
import script from "./inline_parent_invite.vue?vue&type=script&lang=js&"
export * from "./inline_parent_invite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports